import { render, staticRenderFns } from "./BAVideoToolBar.vue?vue&type=template&id=6a637920&scoped=true&"
import script from "./BAVideoToolBar.vue?vue&type=script&lang=ts&"
export * from "./BAVideoToolBar.vue?vue&type=script&lang=ts&"
import style0 from "./BAVideoToolBar.vue?vue&type=style&index=0&id=6a637920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a637920",
  null
  
)

export default component.exports